import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@material-ui/core'

const OrderContentDetail = (props) => {
  const details = props.order.lines
  return (
    <TableContainer component={Paper}>
      <Table size="small" sx={{ minWidth: 300 }}>
        <TableHead>
          <TableRow>
            <TableCell align="center" width={'110px'} className="font-weight-bold badge-secondary">
              Cód. Producto
            </TableCell>
            <TableCell align="center" width={'110px'} className="font-weight-bold badge-secondary">
              Cód. Art. Proveedor
            </TableCell>
            <TableCell align="center" width={'110px'} className="font-weight-bold badge-secondary">
              Descripción
            </TableCell>
            <TableCell align="center" width={'30px'} className="font-weight-bold badge-secondary">
              Pack
            </TableCell>
            <TableCell align="center" width={'70px'} className="font-weight-bold badge-secondary">
              Cantidad pedida
            </TableCell>
            {props.order.state === 'Entregado' && (
              <TableCell align="center" width={'70px'} className="font-weight-bold badge-secondary">
                Cantidad entregada
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {details !== undefined &&
            details.map((row, index) => (
              <TableRow
                key={`table-order-content-detail-${index}`}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell align="right">{row.internalArticleCode}</TableCell>
                <TableCell align="right">{row.providerArticleCode}</TableCell>
                <TableCell align="left">{row.articleDescription}</TableCell>
                <TableCell align="right">{row.articlePack}</TableCell>
                <TableCell align="right">{row.orderedQuantity}</TableCell>
                {props.order.state === 'Entregado' && (
                  <TableCell align="right">{row.servedQuantity}</TableCell>
                )}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default OrderContentDetail
